import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  sectionTitleIndent: {
    marginBottom: '20px'
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%'
  },
  item: {
    flex: '0 0 47%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e2ebf6',
    paddingBottom: '15px',
    marginBottom: '15px',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 'bold'
  },
  currency: {
    fontSize: '10px',
    marginRight: '3px'
  },
  field: {
    width: '70px',
    transition: 'transform 0.3s ease',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      transform: (props) => (props.isZoomed ? 'scale(1.6)' : 'scale(1)'),
      marginRight: '20px'
    },
  },
  itemColumn: {
    display: 'flex',
    width: '70px',
    minWidth: '70px',
    alignItems: 'baseLine',
    justifyContent: 'flex-start',
    '&:nth-child(3n+3)': {
      justifyContent: 'flex-end',
      width: '80px',
      minWidth: '80px'
    },
    '&:nth-child(3n+2)': {
      justifyContent: 'center',
      width: 'auto',
      minWidth: 'auto'
    }
  },
  currencyColumn: {
    color: theme.baseUI.color
  },
  error: {
    margin: '0 0 10px'
  }
}));

export default useStyles;
